module.exports = __webpack_public_path__ + "img/play.b7546ae4.svg";